import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Title as CoreTitle } from '@vds-core/typography';
import TitleConfig from './config';
import { TypographyConfig } from '../../index';
import PropTypes from 'prop-types';
import { Fonts } from '../../fonts';
var propTypes = {
  size: PropTypes.oneOf(['XSmall', 'small', 'medium', 'large', 'XLarge', '2XLarge'])
};

var Title = function Title(props) {
  function getTitleFontWeight(typescale, bold, size) {
    //always bold
    return 700;
  }

  return /*#__PURE__*/React.createElement(CoreTitle, _extends({}, props, {
    size: props.size,
    typescale: TypographyConfig.getTypescale(),
    getFontWeight: getTitleFontWeight,
    config: TitleConfig,
    fontsConfig: Fonts
  }));
};

export default Title;